module.exports = __webpack_public_path__ + "static/media/remove_proj.2b62bc9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/remove_proj.jpg
// module id = 1845
// module chunks = 0